export enum ProfitType {
    RipeToken = 1,
}